import type { FoundryAsset } from '../types'

interface Props {
  asset: FoundryAsset
  selected?: boolean
  onSelect?: () => void
  onView?: () => void
}

export function AssetCard({ asset, selected, onSelect, onView }: Props) {
  const handleClick = () => {
    if (onSelect) onSelect()
    else if (onView) onView()
  }

  return (
    <button
      onClick={handleClick}
      className={`group relative rounded-lg overflow-hidden border transition-all text-left ${
        selected
          ? 'border-forge-ember ring-1 ring-forge-ember/50'
          : 'border-forge-slate hover:border-forge-ember/40'
      }`}
    >
      <div className="aspect-square bg-forge-basalt">
        <img
          src={asset.url}
          alt={asset.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="p-2 bg-forge-obsidian">
        <p className="text-[11px] font-semibold text-forge-primary truncate">{asset.name}</p>
        <div className="flex items-center gap-1 mt-0.5">
          <span className={`text-[9px] px-1.5 py-0.5 rounded-full font-semibold uppercase tracking-wider ${
            asset.type === 'character'
              ? 'bg-forge-ember/10 text-forge-ember'
              : 'bg-forge-gold/10 text-forge-gold'
          }`}>
            {asset.type}
          </span>
          {asset.source === 'captured' && (
            <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-forge-green/10 text-forge-green font-semibold uppercase tracking-wider">
              captured
            </span>
          )}
        </div>
        {asset.tags.length > 0 && (
          <div className="flex flex-wrap gap-0.5 mt-1">
            {asset.tags.slice(0, 4).map((t) => (
              <span key={t} className="text-[8px] text-forge-cool-smoke">
                {t}
              </span>
            ))}
            {asset.tags.length > 4 && (
              <span className="text-[8px] text-forge-cool-smoke">+{asset.tags.length - 4}</span>
            )}
          </div>
        )}
      </div>

      {selected && (
        <div className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-forge-ember flex items-center justify-center">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
      )}
    </button>
  )
}
